import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var WinkSmile = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z",
    key: "k0"
  }), React.createElement("path", {
    d: "M14.828 14.828a3.988 3.988 0 01-2.02 1.09 4.108 4.108 0 01-1.616 0 4.103 4.103 0 01-.749-.232 4.161 4.161 0 01-.679-.368 4.115 4.115 0 01-1.082-1.082l-1.658 1.117c.215.319.462.619.733.889a5.991 5.991 0 008.485.002c.272-.271.52-.571.734-.891l-1.658-1.117c-.143.211-.307.41-.49.592z",
    key: "k1"
  }), React.createElement("circle", {
    cx: 8.5,
    cy: 10.5,
    r: 1.5,
    key: "k2"
  }), React.createElement("path", {
    d: "M15.5 10c-2 0-2.5 2-2.5 2h5s-.501-2-2.5-2z",
    key: "k3"
  }));
});
WinkSmile.displayName = 'WinkSmile';
export var WinkSmileDimensions = {
  height: 24,
  width: 24
};